// extracted by mini-css-extract-plugin
export default {"Container":"VideoImage_Container__jICAs","DeskWrap":"VideoImage_DeskWrap__VfRDr","ImgDesk":"VideoImage_ImgDesk__PJ08M","ToolBox":"VideoImage_ToolBox__MqmQb"};